import { v7 } from 'uuid';

export const Guid = () => {
	return v7();
};
